import { Filter } from "./Filter";

export class FilterGroup extends Filter
{
  static groupFilters( filters:Filter[] )
  {
    let filtersWithGroups:Filter[] = [];

    let groupFilterMap = new Map<string,FilterGroup>();

    for ( let f of filters )
    {
      if ( ! (  f.group && f.group !== "" ) )
      {
        filtersWithGroups.push( f );
        continue;
      }

      if ( ! f.enabled )
      {
        continue;
      }

      if ( ! groupFilterMap.has( f.group ) )
      { 
        let newFilterGroup = new FilterGroup( f.group );
        groupFilterMap.set( f.group, newFilterGroup );
        filtersWithGroups.push( newFilterGroup );
      }

      let filterGroup = groupFilterMap.get( f.group );
      filterGroup.filters.push( f );

    }




    return filtersWithGroups;
    
  }

  filters:Filter[] = [];
  _filterGroup:string;

  constructor( group:string )
  {
    super( null );
    this._filterGroup = group;
    this.enabled = true;
    this.selector = null;
  }

  _filterElement( e:Element ) :boolean 
  {
    for ( let f of this.filters )
    {
      if ( f.filterElement( e ) )
      {
        return true;
      }
    }

    return false;
  }
}